import { ProviderType, ReportingCenter, TrackingEvent } from '@/reporting';
import { TrackEventFunction } from 'index';
import { useCallback } from 'react';

export function useReporting() {
  /**
   * 追踪事件 - 支持两种调用模式：
   *
   * 模式1 - 直接事件追踪 (保持向后兼容)：
   * trackEvent(event, specificProviders, adaptionData?)
   *
   * 模式2 - 适配器模式：
   * trackEvent(event?, specificProviders, adaptionData, adapterType)
   */
  const trackEvent: TrackEventFunction = useCallback(
    (
      event: TrackingEvent | undefined,
      specificProviders: ProviderType[],
      adaptionData?: unknown,
      adapterType?: string,
    ) => {
      // 检查是否在客户端环境中
      if (typeof window === 'undefined') {
        // 服务端环境，直接返回，不执行追踪
        return;
      }

      const center = ReportingCenter.getInstance();
      center.track(event, specificProviders, adaptionData, adapterType);
    },
    [],
  );

  return { trackEvent };
}
